import { LinkButton } from '@/components/Button';
import { Flex } from '@/components/Grid';
import { Link } from '@/components/Link';
import { Text } from '@/components/Text';
import { useModal } from '@/hooks/useModal';
import { useAccount } from '@/resource/account';
import { type AdItemType } from '@/resource/ad';

type Props = {
  ad: AdItemType;
};

export function RespondToAd({ ad }: Props) {
  const modal = useModal();
  const { profile, unreadMessages } = useAccount();
  const unreadMessageCount = unreadMessages.filter(
    (message) => message.ad_id === ad.id
  ).length;
  const adProfile = ad.profile.data;

  return (
    <Flex dir="column" gap={2}>
      {unreadMessageCount > 0 ? (
        <h4>{adProfile.first_name} heeft gereageerd</h4>
      ) : (
        <>
          {ad.type === 'offer' ? (
            <h4>Wil jij hulp van {adProfile.first_name}?</h4>
          ) : (
            <h4>Wil jij {adProfile.first_name} helpen?</h4>
          )}
        </>
      )}

      <LinkButton
        badge={unreadMessageCount}
        to={profile ? { type: 'start_conversation', ad } : { type: 'home' }}
        onClick={(e, refocus) => {
          if (!profile) {
            e.preventDefault();

            modal.open(
              {
                type: 'login',
                props: {
                  title: `Om ${adProfile.first_name} een bericht te sturen moet je ingelogd zijn`,
                },
              },
              refocus
            );
          } else if (profile.deactivated) {
            e.preventDefault();
            modal.open(
              {
                type: 'message',
                props: {
                  title: 'Je account is gedeactiveerd',
                  description: (
                    <Text align="center">
                      <Link to={{ type: 'profile_status' }} underline>
                        Heractiveer je account
                      </Link>{' '}
                      om {adProfile.first_name} een bericht te sturen.
                    </Text>
                  ),
                },
              },
              refocus
            );
          }
        }}
      >
        {unreadMessageCount > 0 ? 'Antwoorden' : 'Stuur een bericht'}
      </LinkButton>
    </Flex>
  );
}
